import { useMessages } from '../i18n';

/** The "Admin Panel" qualifier that tells this app's sign-in and menu from the seller panel's. */
export function PlatformTag() {
    const t = useMessages();
    return (
        <span className="rounded-badge border border-border bg-card px-2 py-px text-12 font-medium tracking-label text-muted-foreground uppercase">
            {t.panelName}
        </span>
    );
}
